export default __webpack_public_path__ + "80d574bce22483bc6e45b550f2b9e0d8.svg";